import { render, staticRenderFns } from "./Github.vue?vue&type=template&id=7d62a566"
import script from "./Github.vue?vue&type=script&lang=js"
export * from "./Github.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports